<template>
    <section class="bg-white container-global q-py-xl">
        <div class="">
            <div class="header_section">
                <h3 class="header_section-title">
                    أول أداة سعودية
                </h3>
                <p class="header_section-description">
                    تلبي احتياجات السوق المحلي في مجالات تجربة المستخدم الرقمية
                </p>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
// No logic needed for this simple component
</script>

<style scoped lang="scss">

</style>